import React from 'react';
import Radio from 'antd/lib/radio';
import { t } from 'utils/i18n';

export type WorkspaceMode = 'drawings' | 'references';

interface Props {
    mode: WorkspaceMode;
    drawings: number | null;
    references: number | null;
    busy: boolean;
    onSwitch(mode: WorkspaceMode): void;
    // a hover is a likely switch: a head start for loading the other mode
    onIntent?(): void;
}

function label(text: string, count: number | null): JSX.Element {
    return (
        <>
            {text}
            {count !== null && <span className='cvat-workspace-mode-count'>{count}</span>}
        </>
    );
}

export default function ModeSwitch({
    mode, drawings, references, busy, onSwitch, onIntent,
}: Props): JSX.Element {
    const noReferences = references === 0;
    return (
        <Radio.Group
            className='cvat-workspace-mode-switch'
            optionType='button'
            value={mode}
            disabled={busy}
            onChange={(event) => onSwitch(event.target.value)}
            onMouseEnter={onIntent}
        >
            <Radio.Button value='drawings'>{label(t('Drawings'), drawings)}</Radio.Button>
            {/* antd drops `title` on Radio.Button, so the explanation sits on a wrapper */}
            <span title={noReferences ? t('No references linked to this task') : undefined}>
                <Radio.Button value='references' disabled={busy || noReferences}>
                    {label(t('References'), references)}
                </Radio.Button>
            </span>
        </Radio.Group>
    );
}
